module.exports = __webpack_public_path__ + "img/qq.882e8089.svg";